import { createFileRoute } from "@tanstack/react-router";
import { BlackFridayLanding } from "@/components/BlackFridayLanding";

const title = "Black Friday 2026: Google Maps + SEO $750/mo | Colorado Web Impressions";
const description = "Black Friday 2026 special: Google Maps and local SEO for $750 a month. Get found by local customers across Colorado. Month-to-month, no locked contracts.";

export const Route = createFileRoute("/black-friday-seo")({
  head: () => ({ meta: [
    { title }, { name: "description", content: description },
    { property: "og:title", content: title }, { property: "og:description", content: description },
    { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary_large_image" },
  ] }),
  component: () => <BlackFridayLanding offer={{
    slug: "black-friday-seo",
    eyebrow: "Black Friday 2026 Special",
    headline: "Google Maps + SEO",
    price: "$750",
    period: "/mo",
    exclusivity: "New customers only",
    subhead: "Get found by local customers on Google Maps and in search, with a plan built around your Colorado service area. First-time clients only.",
    includes: ["Google Business Profile optimization", "Local SEO for your service area", "Month-to-month, no locked contracts", "Handled personally by Chris"],
    topic: "Black Friday 2026: Google Maps + SEO $750/mo",
  }} />,
});
